import {
  FETCH_VEHICLES_CATEGORIES_DATA,
  FETCH_VEHICLES_CATEGORIES_SUCCESS,
  FETCH_VEHICLES_CATEGORIES_FAILURE,
  FETCH_VEHICLES_CATEGORIES_EDIT_DATA,
  FETCH_VEHICLES_CATEGORIES_EDIT_SUCCESS,
  FETCH_VEHICLES_CATEGORIES_EDIT_FAILURE,
} from "./actionTypes";

export const fetchVehiclesCategoriesData = () => ({
  type: FETCH_VEHICLES_CATEGORIES_DATA,
});

export const fetchVehiclesCategoriesSuccess = (data) => ({
  type: FETCH_VEHICLES_CATEGORIES_SUCCESS,
  payload: data,
});

export const fetchVehiclesCategoriesFailure = (error) => ({
  type: FETCH_VEHICLES_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchVehiclesCategoriesEditData = (id) => ({
  type: FETCH_VEHICLES_CATEGORIES_EDIT_DATA,
  payload: id,
});

export const fetchVehiclesCategoriesEditSuccess = (data) => ({
  type: FETCH_VEHICLES_CATEGORIES_EDIT_SUCCESS,
  payload: data,
});

export const fetchVehiclesCategoriesEditFailure = (error) => ({
  type: FETCH_VEHICLES_CATEGORIES_EDIT_FAILURE,
  payload: error,
});
